import { Dispatch, useEffect} from "react";
import { Battery } from "../types";
import { actions } from "../state";
import {IADPHeaderActions } from "../state/Actions";
const logPrefix = "[ADPClient][BatteryServiceHook]"
export function useBatteryService(dispatch: Dispatch<IADPHeaderActions>) {
  //const [battery] = useState<Record<string, unknown>>();
  async function getBatteryLevel() {
    // @ts-ignore
    const batteryLevel:Battery = await navigator.getBattery();
    dispatch(actions.createSetBatteryAction(batteryLevel));
    // @ts-ignore
    navigator.getBattery().then((battery) => {
      battery.onchargingchange = () => {
          console.log(logPrefix,`battery is charging: ${battery.charging}]`);
         
         // DeviceMetricsService.patch(battery.level?.toString());
         dispatch(actions.createSetBatteryAction(battery));
       };
      battery.onlevelchange = () => {
          console.log(logPrefix,`battery level: ${battery.level * 100}]`);
         // DeviceMetricsService.patch(battery.level?.toString());
         dispatch(actions.createSetBatteryAction(battery));
      };
    
  });
    
}
  useEffect(() => {
    getBatteryLevel();
  }, []);
}


